import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { IconSet, TagTheme } from '@fcom/ui-components';

export interface SeatBenefitTag {
  textKey: string;
  theme?: TagTheme;
  icon?: IconSet;
}

@Component({
  selector: 'fin-seat-benefit',
  templateUrl: './seat-benefit.component.html',
  styleUrl: './seat-benefit.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SeatBenefitComponent {
  @Input() descriptionKey: string;

  @Input() tag: SeatBenefitTag;
}
